/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.notification.defs'

export { $nsid }

type RecordDeleted = { $type?: 'app.bsky.notification.defs#recordDeleted' }

export type { RecordDeleted }

const recordDeleted = /*#__PURE__*/ l.typedObject<RecordDeleted>(
  $nsid,
  'recordDeleted',
  /*#__PURE__*/ l.object({}),
)

export { recordDeleted }

/** @deprecated use chat.bsky.notification preferences instead. This will only return a default value. */
type ChatPreference = {
  $type?: 'app.bsky.notification.defs#chatPreference'
  include: 'all' | 'accepted' | l.UnknownString
  push: boolean
}

export type { ChatPreference }

/** @deprecated use chat.bsky.notification preferences instead. This will only return a default value. */
const chatPreference = /*#__PURE__*/ l.typedObject<ChatPreference>(
  $nsid,
  'chatPreference',
  /*#__PURE__*/ l.object({
    include: /*#__PURE__*/ l.string<{ knownValues: ['all', 'accepted'] }>(),
    push: /*#__PURE__*/ l.boolean(),
  }),
)

export { chatPreference }

type FilterablePreference = {
  $type?: 'app.bsky.notification.defs#filterablePreference'
  include: 'all' | 'follows' | l.UnknownString
  list: boolean
  push: boolean
}

export type { FilterablePreference }

const filterablePreference = /*#__PURE__*/ l.typedObject<FilterablePreference>(
  $nsid,
  'filterablePreference',
  /*#__PURE__*/ l.object({
    include: /*#__PURE__*/ l.string<{ knownValues: ['all', 'follows'] }>(),
    list: /*#__PURE__*/ l.boolean(),
    push: /*#__PURE__*/ l.boolean(),
  }),
)

export { filterablePreference }

type Preference = {
  $type?: 'app.bsky.notification.defs#preference'
  list: boolean
  push: boolean
}

export type { Preference }

const preference = /*#__PURE__*/ l.typedObject<Preference>(
  $nsid,
  'preference',
  /*#__PURE__*/ l.object({
    list: /*#__PURE__*/ l.boolean(),
    push: /*#__PURE__*/ l.boolean(),
  }),
)

export { preference }

type Preferences = {
  $type?: 'app.bsky.notification.defs#preferences'

  /**
   * @deprecated use chat.bsky.notification preferences instead. This will only return a default value.
   */
  chat: ChatPreference
  follow: FilterablePreference
  like: FilterablePreference
  likeViaRepost: FilterablePreference
  mention: FilterablePreference
  quote: FilterablePreference
  reply: FilterablePreference
  repost: FilterablePreference
  repostViaRepost: FilterablePreference
  starterpackJoined: Preference
  subscribedPost: Preference
  unverified: Preference
  verified: Preference
}

export type { Preferences }

const preferences = /*#__PURE__*/ l.typedObject<Preferences>(
  $nsid,
  'preferences',
  /*#__PURE__*/ l.object({
    chat: /*#__PURE__*/ l.ref<ChatPreference>((() => chatPreference) as any),
    follow: /*#__PURE__*/ l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    like: /*#__PURE__*/ l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    likeViaRepost: /*#__PURE__*/ l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    mention: /*#__PURE__*/ l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    quote: /*#__PURE__*/ l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    reply: /*#__PURE__*/ l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    repost: /*#__PURE__*/ l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    repostViaRepost: /*#__PURE__*/ l.ref<FilterablePreference>(
      (() => filterablePreference) as any,
    ),
    starterpackJoined: /*#__PURE__*/ l.ref<Preference>(
      (() => preference) as any,
    ),
    subscribedPost: /*#__PURE__*/ l.ref<Preference>((() => preference) as any),
    unverified: /*#__PURE__*/ l.ref<Preference>((() => preference) as any),
    verified: /*#__PURE__*/ l.ref<Preference>((() => preference) as any),
  }),
)

export { preferences }

type ActivitySubscription = {
  $type?: 'app.bsky.notification.defs#activitySubscription'
  post: boolean
  reply: boolean
}

export type { ActivitySubscription }

const activitySubscription = /*#__PURE__*/ l.typedObject<ActivitySubscription>(
  $nsid,
  'activitySubscription',
  /*#__PURE__*/ l.object({
    post: /*#__PURE__*/ l.boolean(),
    reply: /*#__PURE__*/ l.boolean(),
  }),
)

export { activitySubscription }

/** Object used to store activity subscription data in stash. */
type SubjectActivitySubscription = {
  $type?: 'app.bsky.notification.defs#subjectActivitySubscription'
  subject: l.DidString
  activitySubscription: ActivitySubscription
}

export type { SubjectActivitySubscription }

/** Object used to store activity subscription data in stash. */
const subjectActivitySubscription =
  /*#__PURE__*/ l.typedObject<SubjectActivitySubscription>(
    $nsid,
    'subjectActivitySubscription',
    /*#__PURE__*/ l.object({
      subject: /*#__PURE__*/ l.string({ format: 'did' }),
      activitySubscription: /*#__PURE__*/ l.ref<ActivitySubscription>(
        (() => activitySubscription) as any,
      ),
    }),
  )

export { subjectActivitySubscription }
